// extracted by mini-css-extract-plugin
module.exports = {"raceContainer":"_de1a25d","leaderboard":"_ddc3957","table":"_0556177","header":"_f20a9d7"};